import React, { FunctionComponent } from 'react';
import ExperimentCard from '../components/ExperimentCard';
import { Hero, Story, Expertise, Timeline, ExperimentsPreview, CallToAction } from '../components/home/Sections';

// Future: fetch or import experiments data.

const HomePage: FunctionComponent = () => {
  return (
    <>
      <Hero />
      <Story />
      <Expertise />
      <Timeline />
      <ExperimentsPreview>
        <ExperimentCard
          experiment={{
            title: 'Reorderable List',
            description: 'Click or drag to reorder items. Demonstrates immutable updates + framer-motion.',
            route: '/experiments/reorderable-list',
            kind: 'reorderable-list'
          }}
        />
        <ExperimentCard
          experiment={{
            title: 'Photo Gallery',
            description: 'Drop in a folder of photos and scroll through them. A source-agnostic gallery built local-first.',
            route: '/experiments/photo-gallery',
            kind: 'photo-gallery'
          }}
        />
        <ExperimentCard
          experiment={{
            title: 'ScrapHeap Sprint',
            description: 'A Unity-powered racing game with obstacles and power-ups. Navigate through challenging courses in this 3D adventure.',
            route: '/experiments/scrapheap-sprint',
            kind: 'unity-game'
          }}
        />
      </ExperimentsPreview>
      <CallToAction />
    </>
  );
};

export default HomePage;
